export default __webpack_public_path__ + "static/media/Use-Cases-Section-Learning.a525fa13.jpg";